import { StyleSheet } from 'react-native';
import { Colors, grid } from '@shared/styles';

export const Styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  inputContainer: {
    borderRadius: 20,
    overflow: 'hidden',
    backgroundColor: Colors.v2.gray05,
    justifyContent: 'flex-end',
    flexGrow: 1,
    flexShrink: 1,
    marginVertical: 4,
    paddingLeft: grid(2),
  },
  cancelButton: {
    paddingHorizontal: 6, // same padding as when the inputContainer has
    // no buttons to the left and/or right of it
    height: 38, // 40 - 2px border
    alignItems: 'center',
  },
  alignBottom: { justifyContent: 'flex-end' },
  gifModal: {
    height: '60vh',
    // Note: if width is wider than 640px (MBModal max width for web),
    // the content will be wider than the modal content. Instead we
    // cap the mobile width of the GIF search modal to the same value
    // as it is on desktop. This is only relevant for eg tablets
    maxWidth: 480,
  },
  gifModalDesktop: {
    width: 600,
    minHeight: '50vh',
    maxHeight: '90vh',
  },
});
